import { useConsent, usePendo } from "@newsela/snitch";

import { DATAGRAIL_PERFORMANCE_CATEGORY } from "@/datagrailIntegration/config";
import { PENDO_ENABLED } from "../config";

import useAggregatedPendoUser from "./useAggregatedPendoUser";

const PendoTrackingContainer = () => {
  const { user, isReady } = useAggregatedPendoUser();
  const hasConsent = useConsent(DATAGRAIL_PERFORMANCE_CATEGORY);

  usePendo({
    user,
    enabled: PENDO_ENABLED && isReady,
    isConsentGranted: hasConsent,
    product: "lyceum",
  });

  return null;
};

export default PendoTrackingContainer;
